const menuLinks = document.querySelectorAll('.menu li a[href^="#"]');

function getDistanceFromTheTop(element) {
    const id = element.getAttribute("href");
    return document.querySelector(id).offsetTop;
}

function scrollToSection(event) {
    event.preventDefault();
    const distanceFromTheTop = getDistanceFromTheTop(event.target) - 50;
    smoothScrollTo(0, distanceFromTheTop);
    menuLinks.forEach((link) => {
        link.classList.remove("font-bold");
        link.classList.add("hover:text-underline", "hover:text-gray-800");
    });
    event.target.classList.add("font-bold")
    event.target.classList.remove("hover:text-underline", "hover:text-gray-800");
}

menuLinks.forEach((link) => {
    link.addEventListener("click", scrollToSection);
});

function smoothScrollTo(endX, endY, duration) {
    const startX = window.scrollX;
    const startY = window.scrollY;
    const distanceX = endX - startX;
    const distanceY = endY - startY;
    const startTime = new Date().getTime();

    duration = typeof duration !== "undefined" ? duration : 400;

    const easeInOutQuart = (time, from, distance, duration) => {
        if ((time /= duration / 2) < 1)
            return (distance / 2) * time * time * time * time + from;
        return (-distance / 2) * ((time -= 2) * time * time * time - 2) + from;
    };

    const timer = setInterval(() => {
        const time = new Date().getTime() - startTime;
        const newX = easeInOutQuart(time, startX, distanceX, duration);
        const newY = easeInOutQuart(time, startY, distanceY, duration);
        if (time >= duration) {
            clearInterval(timer);
        }
        window.scroll(newX, newY);
    }, 1000 / 60);
}



const sections = document.querySelectorAll("[data-section]");
window.onscroll = () => {
  var current = "";

  sections.forEach((section) => {
    const sectionTop = section.offsetTop;
    if (pageYOffset >= sectionTop - 60) {
      current = section.getAttribute("id");
    }
  });

  menuLinks.forEach((link) => {
    link.classList.remove("font-bold");
    link.classList.add("hover:text-underline", "hover:text-gray-800");
      if (link.getAttribute("href") === `#${current}`) {
        link.classList.add("font-bold");
        link.classList.remove("hover:text-underline", "hover:text-gray-800");
    }
  });
};
